export const getObjLC = (genData = {}, concepts = []) => {
  const safeGenData = genData && typeof genData === "object" ? genData : {};
  const {
    procesamiento = "",
    diverso = "",
    rfc = "",
    nombre = "",
    domicilio = "",
    observaciones = "",
  } = safeGenData;

  const safeConcepts = Array.isArray(concepts) ? concepts : [];

  return {
    MT_ServGralLC_PI_Sender: {
      ES_GEN_DATA: {
        TP_PROCESAMIENTO: procesamiento,
        TP_DATOMAESTRO: "E",
        TP_DIVERSO: diverso,
        RFC: rfc,
        NOMBRE_RAZON: nombre,
        DOMICILIO: domicilio,
        OBSERVACIONES: observaciones,
      },
      TB_CONCEPTOS: safeConcepts.map((concept) => ({
        TP_INGRESO: concept?.TP_INGRESO ?? "",
        CANTIDAD: Number(concept?.CANTIDAD) || concept?.CANTIDAD || 0,
        IMPORTE: Number(concept?.IMPORTE) || Number(concept?.IMPORTE_CONDICION) || 0,
      })),
    },
  };
};
